import { Component, OnInit, ElementRef, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { IFRFitxa } from './fitxes.interfaces';
import { FitxesService } from './fitxes.service';

@Component({
  selector: 'dialog-fitxes',
  templateUrl: './dialog.component.fitxes.html',
  styleUrls: ['./dialog.component.fitxes.scss'],
  providers: [FitxesService, DatePipe]
})

export class DialogFitxes {
  public error: string = '';
  public descripcio: string = '';
  public showAsyncProgress: boolean = false;
  public documentFitxa: IFRFitxa = {'id': 0,'codi': null,'titol': null,'desc_projecte': null,
         'desc_serveis': null, 'idioma': null,'foto1name': null,'foto2name': null};
  public editFitxesData = Object.assign(this.documentFitxa);

  constructor(public translate: TranslateService, public languageService: LanguageService, private datePipe: DatePipe, private fitxesService: FitxesService, public dialogRef: MatDialogRef<DialogFitxes>, @Inject(MAT_DIALOG_DATA) public data: any){ 
   this.fitxesService.get(data, 'ca').subscribe(fitxa => {
        (fitxa?this.editFitxesData = fitxa:this.documentFitxa);
        this.editFitxesData.codi = data;
        if(!this.editFitxesData.idioma)this.editFitxesData.idioma = 'ca';
       }, err => {return;});
  }

  public onFileChange(event, camp) {
   let reader = new FileReader();

   if(event.target.files && event.target.files.length > 0) {
     let file = event.target.files[0];
     reader.readAsDataURL(file);
     reader.onload = () => {
       if(file.size > 5000000){
         alert("Limit del fitxer a pujar 5Mb!");
         this.editFitxesData[camp+"name"] = '';
         return;
       };
       this.editFitxesData[camp+"name"] = file.name;
       this.editFitxesData[camp] = {
         filename: file.name,
         filetype: file.type,
         value: reader.result
       };
    };
   }else {this.editFitxesData[camp] = null;this.editFitxesData[camp+"name"] = '';}
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  desar(): void {
    this.fitxesService.update(this.editFitxesData)
      .subscribe(updatedClientSoci => {this.dialogRef.close();console.log("S'han desat les dades");
    });
  }

  canviar(ev): void {
    this.editFitxesData.id = 0;
    this.editFitxesData.titol = "";
    this.editFitxesData.desc_projecte = "";
    this.editFitxesData.desc_serveis = "";
    this.editFitxesData.foto1name = "";
    this.editFitxesData.foto2name = "";
    this.fitxesService.get(this.editFitxesData.codi, this.editFitxesData.idioma)
      .subscribe(data => { if(data)this.editFitxesData = data;});
  }

  close(): void {
    this.dialogRef.close();
  }

  ngOnInit(){ }

}
